import HttpReference from '../platform/HttpReference';

export default class Driver extends HttpReference {
  async get(email) {
    return this.request({
      params: {email},
    });
  }
}
